export default __webpack_public_path__ + "static/media/as.aa142efd.mp4";